/**
 * MatchConfidenceBadge Component
 *
 * Displays the match confidence level for a property (high/medium/null)
 * Based on Land Registry address validation
 */

import React from "react";
import "./MatchConfidenceBadge.scss";

/**
 * @param {Object} props
 * @param {'high'|'medium'|null} props.confidence - Confidence level
 * @param {'small'|'medium'|'large'} props.size - Badge size
 * @param {boolean} props.showLabel - Whether to show text label
 */
export const MatchConfidenceBadge = ({
  confidence,
  size = "medium",
  showLabel = true,
}) => {
  if (!confidence) {
    return null; // Don't show badge for null confidence
  }

  const getConfig = () => {
    switch (confidence) {
      case "high":
        return {
          emoji: "🟢",
          label: "HIGH",
          className: "high",
          title: "Full address validation (PAON/SAON + street matched)",
        };
      case "medium":
        return {
          emoji: "🟡",
          label: "MEDIUM",
          className: "medium",
          title: "Street-only validation (building number extracted)",
        };
      default:
        return null;
    }
  };

  const config = getConfig();

  if (!config) return null;

  return (
    <span
      className={`match-confidence-badge match-confidence-badge--${config.className} match-confidence-badge--${size}`}
      title={config.title}
    >
      <span className="match-confidence-badge__emoji">{config.emoji}</span>
      {showLabel && (
        <span className="match-confidence-badge__label">{config.label}</span>
      )}
    </span>
  );
};

export default MatchConfidenceBadge;
